import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/shared/common.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AdminsService } from 'src/app/services/Admins/admins.service';
import { TourService } from 'src/app/services/tour-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-selection-modal',
  templateUrl: './user-selection-modal.component.html',
  styleUrls: ['./user-selection-modal.component.scss'],
})
export class UserSelectionModalComponent implements OnInit {
  adminHelpdeskFormgroup: FormGroup; // formgroup for admin/helpdesk
  companynames: any[] = []; // company details
  brokersList: any[] = []; // broker list within the company
  agentList: any[] = []; // agent list for selected broker
  isBrokerFieldHidden: boolean = true; // broken field hidden by default if company is not selected
  isAgentFieldHidden: boolean = true; // agent field hidden by default if broker is not selected
  assetOwnerId: number; // selected agent/broker id
  @Output() selectedUserId = new EventEmitter<number>(); // output event

  constructor(
    private formBuilder: FormBuilder,
    public commonService: CommonService,
    private adminService: AdminsService,
    public bsModalRef: BsModalRef,
    private tourService: TourService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.initializeFormGroup(); // init form builder
    this.fetchCompanyDetails(); //all company details
    this.onFormGroupChanges();
  }

  // initialize form group
  initializeFormGroup() {
    this.adminHelpdeskFormgroup = this.formBuilder.group({
      companyName: ['', Validators.required],
      brokerName: ['', Validators.required],
      agentName: [''],
      companyId: ['', Validators.required],
      brokerId: ['', Validators.required],
      agentId: [''],
    });

  // Subscribe to form data when modal opens
  this.tourService.getFormData().subscribe((savedFormData) => {
    if (savedFormData) {
      this.adminHelpdeskFormgroup.patchValue(savedFormData);
      
      this.isBrokerFieldHidden = !this.adminHelpdeskFormgroup.get('brokerId').value;
      this.isAgentFieldHidden = !this.adminHelpdeskFormgroup.get('agentId').value;
    }
  });
  }

  //company details
  fetchCompanyDetails() {
    this.adminService.GetAllCompanies().subscribe((res: any) => {
      this.companynames = res?.sort((a: any, b: any) =>
        a.name.localeCompare(b.name)
      );
      console.log(this.companynames);
    });
  }

  //upon company selection
  onCompanySelection(event: any, isSavedFormGroup: boolean = false) {
    !isSavedFormGroup &&
      this.adminHelpdeskFormgroup
        .get('companyId')
        .patchValue(event.item.companyAddressId);
    this.isBrokerFieldHidden = false; //show broker field
    //get broker details
    this.adminService
      .GetCompanyIdBrokers(
        isSavedFormGroup ? event : event.item.companyAddressId
      )
      .subscribe((res: any) => {
        this.brokersList = res.sort((a: any, b: any) =>
          a.name.localeCompare(b.name)
        );
      });
    this.adminHelpdeskFormgroup
      .get('brokerId')
      ?.patchValue('', { emitEvent: false });
    this.adminHelpdeskFormgroup
      .get('brokerName')
      ?.patchValue('', { emitEvent: false });
    this.adminHelpdeskFormgroup
      .get('agentId')
      ?.patchValue('', { emitEvent: false });
    this.adminHelpdeskFormgroup
      .get('agentName')
      ?.patchValue('', { emitEvent: false });
    this.isAgentFieldHidden = true;
  }

  //upon broker selection
  onBrokerSelection(event: any, isSavedFormGroup: boolean = false) {
    !isSavedFormGroup &&
      this.adminHelpdeskFormgroup
        .get('brokerId')
        .patchValue(event.item.brokerId);
    this.isAgentFieldHidden = false; // show agent field
    //get agent details from selected broker
    this.adminService
      .GetAgents(isSavedFormGroup ? event : event.item.brokerId, true)
      .subscribe((res: any) => {
        this.agentList = res.sort((a: any, b: any) =>
          a.name.localeCompare(b.name)
        );
      });
    //assign selected brokerId to ownerId
    this.assetOwnerId = isSavedFormGroup ? event : event.item.brokerId;
    this.adminHelpdeskFormgroup
      .get('agentId')
      ?.patchValue('', { emitEvent: false });
    this.adminHelpdeskFormgroup
      .get('agentName')
      ?.patchValue('', { emitEvent: false });
  }

  //upon agent selection
  onAgentSelection(event: any) {
    this.adminHelpdeskFormgroup.get('agentId').patchValue(event.item.userId);
    this.assetOwnerId = event.item.userId; // assign agentId to ownerId
  }

  //upon agent/broker selection
  onAgentBrokerSelection() {
    this.selectedUserId.emit(this.assetOwnerId);
    this.tourService.setFormData(this.adminHelpdeskFormgroup.value);
    this.bsModalRef.hide(); // Close the modal
    // Add ownerId to query params
    this.router.navigate([], {
      queryParams: { ownerId: this.assetOwnerId },
      queryParamsHandling: 'merge', // Preserve existing query params
    });
  }

  onFormGroupChanges() {
    this.adminHelpdeskFormgroup
      .get('companyName')
      .valueChanges.subscribe(() => {
        if (this.companynames.length == 0) this.fetchCompanyDetails();
      });

    this.adminHelpdeskFormgroup.get('brokerName').valueChanges.subscribe(() => {
      if (
        this.brokersList.length == 0 &&
        this.adminHelpdeskFormgroup.get('companyId')?.value
      )
        this.onCompanySelection(
          this.adminHelpdeskFormgroup.get('companyId').value,
          true
        );
    });

    this.adminHelpdeskFormgroup.get('agentName').valueChanges.subscribe(() => {
      if (
        this.agentList.length == 0 &&
        this.adminHelpdeskFormgroup.get('brokerId')?.value
      )
        this.onBrokerSelection(
          this.adminHelpdeskFormgroup.get('brokerId').value,
          true
        );
    });
  }
}
